import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import { ConversationService } from '@forwardflow/services/ConversationService'
import useSWR from 'swr'

interface DemoIncomingCallStatusResponse {
   isDemo: boolean
}

interface UseGetDemoIncomingCallStatusParams {
   leadId?: number
   shouldFetch?: boolean
}

export const useGetDemoIncomingCallStatus = ({ 
   leadId, 
   shouldFetch = true 
}: UseGetDemoIncomingCallStatusParams) => {
   const response = useSWR<DemoIncomingCallStatusResponse>(
      shouldFetch && leadId ? [QUERY_KEYS.DEMO_INCOMING_CALL_STATUS, leadId] : null,
      () => ConversationService.getDemoIncomingCallStatus(leadId!),
      {
         shouldRetryOnError: false,
      }
   )
   return {
      ...response,
      mutate: () => response.mutate()
   }
}